export default "__VITE_ASSET__e34d2d7e__"